import { UseMutationResult, useMutation } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'

import { getUserData, updateUserData } from 'services/me'
import { FamilyContact, ModifiedAddress } from 'models/Auth'
import { AUTH_UPDATE_USER_DATA } from 'redux/actions/_actionTypes'

interface FormValuesData {
  address?: ModifiedAddress
  familyContact?: FamilyContact
}

type UseUpdatePersonGeneralParams = {
  successCallback: () => void
}

type UseUpdatePersonGeneralReturn = {
  onUpdatePersonGeneralData: (data?: FormValuesData) => void
  isUpdateSubmitting: boolean
} & UseMutationResult

export const useUpdatePersonGeneral = ({ successCallback }: UseUpdatePersonGeneralParams): UseUpdatePersonGeneralReturn => {
  const dispatch = useDispatch()
  const result = useMutation({
    mutationFn: updateUserData,
    onSuccess: async() => {
      const data = await getUserData()
      dispatch({ type: AUTH_UPDATE_USER_DATA, payload: data })
      return successCallback()
    }
  })

  return {
    ...result,
    isUpdateSubmitting: result.isLoading,
    onUpdatePersonGeneralData: result.mutate
  }
}